import * as React from "react";
import ITrace from "../../../../interfaces/Trace";

const genericLabel = { top: -15, left: "50%", transform: "translateX(-50%)" };
const firstLabel   = { top: -15, left: 0 };
const lastLabel    = { top: -15, right: 0 };

interface IProps extends ITrace {
  position:string;
  key: number;
  originalPercentage: number;
};

const percentagePlacement = ( n: number ) => ( ( n > 15 ) ? '' : ' c-progress-bar__percentage--alt' );

const Trace = (props: IProps) => (
  <div
    className={`c-progress-bar__item bg-${props.color} h-full float-left relative ${getBorderRadius(props.position)}`}
    style={{ width: `${props.percentage}%`, transition: 'all 0.3s linear' }}
  >
    <span
      className={`c-progress-bar__label hidden lg:block hover-top cursor-pointer bg-white absolute px-1 whitespace-no-wrap text-xs font-bold text-${
        props.color
      }`}
      style={getLabelStyles(props.position)}
    >
      {/* Change this line below to props.originalPercentage if you need the unscaled value */}
      {`${props.label} ${Math.round(props.percentage * 100) / 100}%`}
    </span>
    <span
      className={`c-progress-bar__percentage` + percentagePlacement( Math.round( props.percentage * 100 ) / 100 ) + ` lg:hidden cursor-pointer px-1 whitespace-no-wrap text-xs font-bold text-${
        props.color
      }`}
    >
      {/* Change this line below to props.originalPercentage if you need the unscaled value */}
      {`${Math.round(props.percentage * 100) / 100}%`}
    </span>
  </div>
);

const getLabelStyles = (position: string) => {
  switch(position) {
    case 'first':
      return firstLabel;
    case 'last':
      return lastLabel;
    case 'both':
    case 'none':
    default:
      return genericLabel;
  }
};

const getBorderRadius = (position: string) => {
  switch(position) {
    case 'both':
      return 'rounded-lg';
    case 'first':
      return 'rounded-tl-lg rounded-bl-lg';
    case 'last':
      return 'rounded-tr-lg rounded-br-lg';
    case 'none':
    default:
      return;
  }
};

export default Trace;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/StackedProgressBar/Trace.tsx